const _ = require('lodash');
const { v4: uuidV4 } = require('uuid');

const generateChoicesPassageChooseSentence = ({ bundle }) => {
  const { passage } = bundle;

  const splits = passage.trim().split('|');

  const choices = splits.reduce((acc, piece) => {
    if (piece.length === 0) {
      return acc;
    }

    const firstChar = piece[0];
    const lastChar = piece[piece.length - 1];

    const { correct, markdown } = (() => {
      if (firstChar !== '=' || lastChar !== '=') {
        return {
          correct: false,
          markdown: piece,
        };
      }

      return {
        correct: true,
        markdown: piece.slice(1, -1),
      };
    })();

    const choice = {
      uuid: uuidV4(),
      markdown,
      correct,
    };

    acc.push(choice);
    return acc;
  }, []);

  return choices;
};

module.exports = {
  generateChoicesPassageChooseSentence,
};
